<template>
  <div id="app">
    <top v-if="$route.meta.assembly"/>
    <div>
      <left v-if="$route.meta.assembly"/>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import top from "@/components/layout/top.vue";
import left from "@/components/layout/left.vue";

export default {
  name: "App",
  components: {
    top, //暂无数据组件
    left,
  },
  data() {
    return {};
  },
  methods: {},
  created: function () {
    if (localStorage.getItem("token") == null) {
      this.$router.push("/");
    } else if (
      this.$route.path == "/" &&
      localStorage.getItem("token") != null
    ) {
      this.$router.push("/guide");
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  min-height: 100vh;
  display: block;
  position: absolute;
  width:100%;
  height: 100%;
}

body {
  margin: 0px;
  padding: 0px;
}


body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
  scrollbar-arrow-color: red;
}

body::-webkit-scrollbar-thumb {
  -webkit-box-shadow: rgb(7, 65, 122) 0px 0px 30px inset;
  box-shadow: rgb(7, 65, 122) 0px 0px 30px inset;
  border-radius: 30px;
}

body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: rgb(3, 16, 33);
}

#app >>> .general-frame.is-action {
  width: 100%;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue